import Axios from "../../axios"

// ドメインごとに異なる値
const defaultState = {
    generationList: [
    ],
    documentList: [
    ],
    employeeList: [
    ],
    departmentList: [
    ],
    masterInfo: [

    ],
    documentFrequencyList: [

    ],
    approvalDocumentTimeAverageList: [

    ],
    approvalTimeAverageList: [

    ],
    documentRejectionRateList: [

    ],
    userRejectionRateList: [

    ],
    deviceFrequencyList: [

    ],
    applyDocumentNumber: [

    ]
}

const getters = {
    generationList: state => state.generationList,
    documentList: state => state.documentList,
    employeeList: state => state.employeeList,
    departmentList: state => state.departmentList,
    masterInfo: state => state.masterInfo,
    documentFrequencyList: state => state.documentFrequencyList,
    approvalDocumentTimeAverageList: state => state.approvalDocumentTimeAverageList,
    approvalTimeAverageList: state => state.approvalTimeAverageList,
    documentRejectionRateList: state => state.documentRejectionRateList,
    userRejectionRateList: state => state.userRejectionRateList,
    deviceFrequencyList: state => state.deviceFrequencyList,
    applyDocumentNumber: state => state.applyDocumentNumber
}

const actions = {
    async GET_GENERATION_LIST({ commit }, queries) {
        return Axios
            .get("/generation_list", { params: queries })
            .then(res => {
                const data = res.data;
                commit("SET_GENERATION_LIST", { data })
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            })
    },
    async GET_EMPLOYEE_LIST({ commit }, queries) {
        return Axios
            .get("/employee_list", { params: queries })
            .then(res => {
                const data = res.data;
                commit("SET_EMPLOYEE_LIST", { data })
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            })
    },
    async GET_DOCUMENT_LIST({ commit }, queries) {
        return Axios
            .get("/document_list", { params: queries })
            .then(res => {
                const data = res.data;
                commit("SET_DOCUMENT_LIST", { data })
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            })
    },
    async GET_DEPARTMENT_LIST({ commit }, queries) {
        return Axios
            .get("/department_list", { params: queries })
            .then(res => {
                const data = res.data;
                commit("SET_DEPARTMENT_LIST", { data })
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            })
    },
    async GET_MASTER_INFO({ commit }, queries) {
        return Axios
            .get("/master_info", { params: queries })
            .then(res => {
                const data = res.data;
                commit('SET_MASTER_INFO', { data })
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            })
    },
    async GET_DOCUMENT_FREQUENCY_LIST({ commit }, queries) {
        return Axios
            .get("/graphs/document_count_of_use", { params: queries })
            .then(res => {
                const data = res.data;
                commit('SET_DOCUMENT_FREQUENCY_LIST', { data })
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            });
    },
    async GET_APPROVAL_DOC_TIME_AVERAGE_LIST({ commit }, queries) {
        return Axios
            .get("/graphs/approval_doc_time_average", { params: queries })
            .then(res => {
                const data = res.data;
                commit('SET_APPROVAL_DOC_TIME_AVERAGE_LIST', { data })
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            });
    },
    async GET_APPROVAL_TIME_AVERAGE_LIST({ commit }, queries) {
        return Axios
            .get("/graphs/approval_time_average", { params: queries })
            .then(res => {
                const data = res.data;
                commit('SET_APPROVAL_TIME_AVERAGE_LIST', { data })
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            });
    },
    async GET_DOCUMENT_REJECTION_RATE_LIST({ commit }, queries) {
        return Axios
            .get("/graphs/document_rejection_rate", { params: queries })
            .then(res => {
                const data = res.data;
                commit('SET_DOCUMENT_REJECTION_RATE_LIST', { data })
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            });
    },
    async GET_USER_REJECTION_RATE_LIST({ commit }, queries) {
        return Axios
            .get("/graphs/rejection_rate", { params: queries })
            .then(res => {
                const data = res.data;
                commit('SET_USER_REJECTION_RATE_LIST', { data })
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            });
    },
    async GET_DEVICE_FREQUENCY_LIST({ commit }, queries) {
        return Axios
            .get("/graphs/device_count_of_use", { params: queries })
            .then(res => {
                const data = res.data;
                commit('SET_DEVICE_FREQUENCY_LIST', { data })
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            });
    },
    async GET_APPLY_DOCUMENT_NUMBER({ commit }, queries) {
        return Axios
            .get("/graphs/apply_document_number", { params: queries })
            .then(res => {
                const data = res.data;
                commit('SET_APPLY_DOCUMENT_NUMBER', { data })
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error)
            });
    },
    STATE_INIT({ commit }) {
        commit('STATE_INIT');
    }
}

const mutations = {
    SET_GENERATION_LIST(state, { data }) {
        state.generationList = data;
    },
    SET_EMPLOYEE_LIST(state, { data }) {
        state.employeeList = data;
    },
    SET_DOCUMENT_LIST(state, { data }) {
        state.documentList = data;
    },
    SET_DEPARTMENT_LIST(state, { data }) {
        state.departmentList = data;
    },
    SET_MASTER_INFO(state, { data }) {
        state.masterInfo = data;
    },
    SET_DOCUMENT_FREQUENCY_LIST(state, { data }) {
        state.documentFrequencyList = data;
    },
    SET_APPROVAL_DOC_TIME_AVERAGE_LIST(state, { data }) {
        state.approvalDocumentTimeAverageList = data;
    },
    SET_APPROVAL_TIME_AVERAGE_LIST(state, { data }) {
        state.approvalTimeAverageList = data;
    },
    SET_DOCUMENT_REJECTION_RATE_LIST(state, { data }) {
        state.documentRejectionRateList = data;
    },
    SET_USER_REJECTION_RATE_LIST(state, { data }) {
        state.userRejectionRateList = data;
    },
    SET_DEVICE_FREQUENCY_LIST(state, { data }) {
        state.deviceFrequencyList = data;
    },
    SET_APPLY_DOCUMENT_NUMBER(state, { data }) {
        state.applyDocumentNumber = data;
    },
    STATE_INIT(state) {
        Object.assign(state, defaultState)
    }
}

export default {
    namespaced: true,
    state: JSON.parse(JSON.stringify(defaultState)),
    getters,
    actions,
    mutations
}
